import { render, staticRenderFns } from "./ConsignmentListItem.vue?vue&type=template&id=359f8da4&"
import script from "./ConsignmentListItem.vue?vue&type=script&lang=js&"
export * from "./ConsignmentListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports